import { useInvalidate, useTranslate } from "@refinedev/core";
import { Card, Col, Flex, Typography, theme } from "antd";
import { UserLicenseAssignmentResponse, Workspace } from "types";
import dayjs from "dayjs";
import { addDateTz } from "../../utils";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { MenuCTA } from "components/MenuCTA/";
import { EditWorkspaceModal } from "./EditWorkspaceModal";
import { useMemo, useState } from "react";
import { getCoverImage } from "../helpers/workspaceImages";
// TODO: Uncomment once backend support is ready
// import { Avatar } from "@libertify/ui";
// import { UserIcon } from "@phosphor-icons/react";
// import styled from "styled-components";

// const MAX_VISIBLE_AVATARS = 4;
// const AVATAR_OVERLAP = -12;

interface WorkspaceCardProps {
  workspace: Workspace;
  organizationUsers?: UserLicenseAssignmentResponse[];
  onDeleteSuccess?: () => void | Promise<unknown>;
}

// TODO: Uncomment once backend support is ready
// const AvatarGroupContainer = styled.div`
//   display: flex;
//   align-items: center;
// `;

// const AvatarWrapper = styled.div<{ $index: number }>`
//   margin-left: ${({ $index }) => ($index === 0 ? 0 : AVATAR_OVERLAP)}px;
//   z-index: ${({ $index }) => 10 - $index};
//   position: relative;
// `;

// const ExtraCount = styled.div<{ $bgColor: string; $textColor: string }>`
//   width: 32px;
//   height: 32px;
//   border-radius: 50%;
//   background-color: ${({ $bgColor }) => $bgColor};
//   color: ${({ $textColor }) => $textColor};
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 12px;
//   font-weight: 600;
//   margin-left: ${AVATAR_OVERLAP}px;
//   border: 2px solid white;
// `;

export const WorkspaceCard = ({
  workspace,
  organizationUsers = [],
  onDeleteSuccess,
}: WorkspaceCardProps) => {
  const t = useTranslate();
  const navigate = useNavigate();
  const invalidate = useInvalidate();
  // TODO: Uncomment once backend support is ready
  // const { token } = theme.useToken();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // TODO: Uncomment once backend support is ready
  // const workspaceMembers = useMemo(() => {
  //   return organizationUsers.filter((user) =>
  //     user.workspaces?.includes(workspace.id)
  //   );
  // }, [organizationUsers, workspace.id]);

  // const visibleMembers = workspaceMembers.slice(0, MAX_VISIBLE_AVATARS);
  // const extraCount = workspaceMembers.length - MAX_VISIBLE_AVATARS;

  const onEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleEditSuccess = async () => {
    setIsEditModalOpen(false);
    await invalidate({
      resource: "api/workspaces",
      invalidates: ["list"],
    });
  };

  return (
    <Col xl={8} md={12} xs={24}>
      <StyledCard
        style={{ cursor: "pointer" }}
        styles={{
          cover: {
            aspectRatio: "5 / 2",
          },
        }}
        cover={
          <div
            aria-hidden
            style={{
              height: "100%",
              background: getCoverImage(workspace.id),
            }}
          />
        }
        onClick={() => {
          navigate(`/workspaces/${workspace.id}/detail`, {
            state: {
              workspaceName: workspace.name,
            },
          });
        }}
      >
        <Flex vertical gap={10}>
          <Flex justify="space-between" align="center">
            <Card.Meta title={workspace.name} />
            {workspace.name === "default" ? (
              <div style={{ width: 32, height: 32 }} />
            ) : (
              <span role="presentation" onClick={(e) => e.stopPropagation()}>
                <MenuCTA
                  onEditClick={onEditClick}
                  recordId={workspace.id}
                  resource="api/workspaces"
                  onDeleteSuccess={onDeleteSuccess}
                />
              </span>
            )}
          </Flex>
          <Flex justify="space-between" align="center">
            {/* // TODO: Uncomment once backend support is ready */}
            {/* <AvatarGroupContainer>
              {visibleMembers.map((member, index) => (
                <AvatarWrapper key={member.email} $index={index}>
                  <Avatar
                    size="sm"
                    name={member.user_name || member.email}
                    icon={<UserIcon size={16} weight="fill" />}
                  />
                </AvatarWrapper>
              ))}
              {extraCount > 0 && (
                <ExtraCount
                  $bgColor={token.colorBgTextHover}
                  $textColor={token.colorText}
                >
                  +{extraCount}
                </ExtraCount>
              )}
            </AvatarGroupContainer> */}
            <Typography.Text type="secondary">
              {t("media.workspaces.index.updated", {
                time: dayjs(addDateTz(workspace.updated)).fromNow(),
              })}
            </Typography.Text>
          </Flex>
        </Flex>
      </StyledCard>
      <EditWorkspaceModal
        open={isEditModalOpen}
        workspace={workspace}
        onCancel={() => setIsEditModalOpen(false)}
        onSuccess={handleEditSuccess}
      />
    </Col>
  );
};

const StyledCard = styled(Card)`
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
`;
